import { cn } from "@/lib/utils"
import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react"
import React from "react"
import Link from "next/link"
import styles from "./Button.module.css"

interface SecondaryButtonProps {
  children: React.ReactNode
  href?: string
  className?: string
  target?: string
  rel?: string
  type?: "submit" | "button" | "reset"
  disabled?: boolean
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>
  anchorProps?: AnchorHTMLAttributes<HTMLAnchorElement>
}

export function SecondaryButton({
  children,
  href,
  className = "",
  target,
  rel,
  type = "button",
  disabled,
  buttonProps = {},
  anchorProps = {},
}: SecondaryButtonProps) {
  const baseClasses = cn(styles.secondaryButton, className)

  if (href) {
    const isExternal = target === "_blank" || rel || href.startsWith("http")
    if (isExternal) {
      return (
        <a
          href={href}
          className={baseClasses}
          target={target}
          rel={rel}
          {...anchorProps}
        >
          {children}
        </a>
      )
    }
    // Internal link
    return (
      <Link
        href={href}
        className={baseClasses}
        {...anchorProps}
      >
        {children}
      </Link>
    )
  }
  return (
    <button
      type={type}
      className={baseClasses}
      disabled={disabled}
      {...buttonProps}
    >
      {children}
    </button>
  )
}
